import { InlineOptionSelector, InlineOptionSelectorItem } from "client/Components";
import { IValueInputAttachable } from "client/Forms/attachable";
import { EmailAddressModel } from "client/Api/Email/email";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useMemo } from "react";

export type FromAddressSelectorProps = {
	attachable: IValueInputAttachable<string>;
	options: readonly EmailAddressModel[];
};

export const FromAddressSelector = (props: FromAddressSelectorProps): ReactElement => {
	const {
		attachable,
		options
	} = props;

	const selectOptions = useMemo(
		(): readonly InlineOptionSelectorItem<string>[] => {
			return options.map(o => ({
				text: o.emailAddress,
				value: o.emailAddress
			}));
		},
		[options]
	);

	return (
		<div>
			{localize("_From")}
			<InlineOptionSelector
				{...attachable.attachToSelect()}
				options={selectOptions}
				menuTitle={localize("_From")}
			/>
		</div>
	);
};
FromAddressSelector.displayName = "FromAddressSelector";